import { useEffect } from 'react'


const InstructionsColors = () => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    },[])


    return (
        <div className="InstructionsColor">
            <p className="InstructionsColor__Icon"><i className="bi bi-phone-flip"></i></p>
            <p className="InstructionsColor__Title">Sube el brillo y voltea tu celular para que la pantalla apunte hacia la cancha.</p>
            <p className="InstructionsColor__Title">¡Disfruta la vista!</p>
        </div>
    )
}

export { InstructionsColors };